import { render, staticRenderFns } from "./MaterialListComponent.vue?vue&type=template&id=e1e23112&scoped=true"
import script from "./MaterialListComponent.vue?vue&type=script&lang=js"
export * from "./MaterialListComponent.vue?vue&type=script&lang=js"
import style0 from "./MaterialListComponent.vue?vue&type=style&index=0&id=e1e23112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e23112",
  null
  
)

export default component.exports